var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 4H36V2C36 1.46957 35.7893 0.960859 35.4142 0.585786C35.0391 0.210714 34.5304 0 34 0C33.4696 0 32.9609 0.210714 32.5858 0.585786C32.2107 0.960859 32 1.46957 32 2V4H8V2C8 1.46957 7.78929 0.960859 7.41421 0.585786C7.03914 0.210714 6.53043 0 6 0C5.46957 0 4.96086 0.210714 4.58579 0.585786C4.21071 0.960859 4 1.46957 4 2V4H2C1.46957 4 0.960859 4.21071 0.585786 4.58579C0.210714 4.96086 0 5.46957 0 6V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H4V34C4 34.5304 4.21071 35.0391 4.58579 35.4142C4.96086 35.7893 5.46957 36 6 36C6.53043 36 7.03914 35.7893 7.41421 35.4142C7.78929 35.0391 8 34.5304 8 34V20H32V34C32 34.5304 32.2107 35.0391 32.5858 35.4142C32.9609 35.7893 33.4696 36 34 36C34.5304 36 35.0391 35.7893 35.4142 35.4142C35.7893 35.0391 36 34.5304 36 34V20H38C38.5304 20 39.0391 19.7893 39.4142 19.4142C39.7893 19.0391 40 18.5304 40 18V6C40 5.46957 39.7893 4.96086 39.4142 4.58579C39.0391 4.21071 38.5304 4 38 4ZM4 13.04V8H9.04L4 13.04ZM6.68 16L14.68 8H21.34L13.34 16H6.68ZM18.98 16L26.98 8H33.34L25.34 16H18.98ZM36 16H30.98L36 10.98V16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4);
export default __webpack_public_path__ + "static/media/img4.0582841cc3024cb5464d45ac7926c558.svg";
export { ForwardRef as ReactComponent };